/** Small shared form UX bits: submit-with-spinner, error banner. */
import type { ReactNode } from 'react';
import { cn } from '../utils.js';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent align-middle',
        className,
      )}
    />
  );
}

export function SubmitButton({
  busy,
  children,
  busyLabel,
  className,
}: {
  busy: boolean;
  children: ReactNode;
  busyLabel: string;
  className?: string;
}) {
  return (
    <button
      type="submit"
      disabled={busy}
      className={cn(
        'flex w-fit items-center gap-2 rounded-md bg-primary px-6 py-2 font-semibold text-primary-foreground disabled:opacity-60',
        className,
      )}
    >
      {busy && <Spinner />}
      {busy ? busyLabel : children}
    </button>
  );
}

/** `title` defaults to the upload wording — sign-in screens pass their own. */
export function ErrorBanner({ error, title = 'הקליטה נכשלה' }: { error: string | null; title?: string }) {
  if (!error) return null;
  return (
    <div className="mt-4 flex items-start gap-2 rounded-lg border border-red-300 bg-red-50 p-4 text-sm text-red-800">
      <span className="font-bold">✕</span>
      <div>
        <p className="font-semibold">{title}</p>
        <p className="mt-0.5" dir="auto">{error}</p>
      </div>
    </div>
  );
}
